"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _QqCircleFilled = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/QqCircleFilled"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var QqCircleFilled = function QqCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _QqCircleFilled.default
  }));
};

/**![qq-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0yMTAuNSA2MTIuNGMtMTEuNSAxLjQtNDQuOS01Mi43LTQ0LjktNTIuNyAwIDMxLjMtMTYuMiA3Mi4yLTUxLjEgMTAxLjggMTYuOSA1LjIgNTQuOSAxOS4yIDQ1LjkgMzQuNC03LjMgMTIuMy0xMjUuNiA3LjktMTU5LjggNC0zNC4yIDMuOC0xNTIuNSA4LjMtMTU5LjgtNC05LjEtMTUuMiAyOC45LTI5LjIgNDUuOC0zNC40LTM1LTI5LjUtNTEuMS03MC40LTUxLjEtMTAxLjggMCAwLTMzLjQgNTQuMS00NC45IDUyLjctNS40LS43LTEyLjQtMjkuNiA5LjQtOTkuNyAxMC4zLTMzIDIyLTYwLjUgNDAuMi0xMDUuOC0zLjEtMTE2LjkgNDUuMy0yMTUgMTYwLjQtMjE1IDExMy45IDAgMTYzLjMgOTYuMSAxNjAuNCAyMTUgMTguMSA0NS4yIDI5LjkgNzIuOCA0MC4yIDEwNS44IDIxLjcgNzAuMSAxNC42IDk5LjEgOS4zIDk5Ljd6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/React.forwardRef(QqCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'QqCircleFilled';
}
var _default = exports.default = RefIcon;